$(".wrapper-crea-spe .produits span").css("opacity", "0");

$(window).load(function () {

    if (showForm()) {
        Foundation.libs.scroll.moveTo($("#zone-frm-demande-crea"))
    }

});

function showForm() {
    var field = 'showForm';
    var url = window.location.href;
    if (url.indexOf('?' + field + '=') != -1)
        return true;
    else if (url.indexOf('&' + field + '=') != -1)
        return true;
    return false
}

$(document).ready(function () {
    initDemande('CreaSpeciales');

    // Binding controle d'adresse
    if ($('#AdresseExpedition_IsPaysGereParWSLaPoste').val() == 'True') {
        bindLaPosteDemandeClient();
    }

    // Gestion du "Enter" lorsqu'on est sur les champs email/mots de passe => doit simuler click sur bouton "connecter" et non sur le bouton de demande de catalogue
    $("#Identification_Password, #Identification_Login").on("keydown", function (e) {
        if (e.keyCode == "13") {
            e.preventDefault();
            $("#btConnecter").trigger("click");
            return false;
        }



    });

    // On red�fini le page wrapper pour que une fois l'adresse modifi�e on ne remonte pas jusqu'en haut de la page
    pageWrapper = $(".demande-wrapper");



    $(".js-upload").each(function () {
        // Initialise le file Input avec un poids mini de 5 Ko et max de 5000 Ko
        new FileInput(this, {
            minKo: 5,
            maxKo: 5000,
            onChange: function () {
                var _this = this;
                if (this.file.ext === "pdf") {

                    this.DOM.input.parent().append('<div class="a-fileInputPicture__preview">' + this.file.name + '</div>')
                } else {
                    this.DOM.input.parent().css("backgroundImage", "url(" + this.file.src + ")");

                }
                this.DOM.input.parent().addClass("-active");
                this.DOM.input.siblings("div").on("click", function () {
                    _this.removeFile();
                })

            },
            onRemove: function () {
                if (this.file.ext === "pdf") {

                    this.DOM.input.siblings(".a-fileInputPicture__preview").remove();
                } else {
                    this.DOM.input.parent().css("backgroundImage", "");
                }

                this.DOM.input.parent().removeClass("-active")
            }
        });
    });

    $(".js-input-change").each(function () {
        new InputChoice(this);
    });

    let productSlidersSections = document.querySelectorAll('section.product-slider');
    if (productSlidersSections !== null && productSlidersSections !== undefined && productSlidersSections.length > 0) {
        productSlidersSections.forEach((item) => {
            $(item).find('.owl-carousel').owlCarousel({
                loop: true,
                margin: 50,
                touchDrag: true,
                lazyLoad: false,
                center: false,
                mergeFit: false,
                autoWidth: true,
                checkVisibility: true,
                dots: false,
                nav: true,
                responsive: {
                    0: {
                        items: 1,
                        nav: true,
                        dots: false,
                    },
                    450: {
                        nav: true,
                    },
                },
            })
        })
    }
});
